// TODO: Apply constants to where needed
export const DESKTOP_HEADER_HEIGHT = 72;
export const MOBILE_HEADER_HEIGHT = 67;

export enum SpinnerSize {
  Small = 'Small',
  Large = 'Large',
}
